/** Factored out of library so concert-pitch can read a chord symbol without an import cycle (GH #2990) */

import { ALL_CHORDS } from './all-chords.js'
import type { ChordVariant } from './chord-types.js'
import { normalizeChordSymbol, parseChordString } from './chord-regexp.js'

export const fromName = (name: string): ChordVariant | undefined => {
  /** `C7♭13`, `C7(b9)` and `Cm(maj7)` are their ASCII, parenthesis-free spellings (GH #2646) */
  const symbol = normalizeChordSymbol(name)
  const parsedChord = parseChordString(symbol)
  if (parsedChord) {
    return parsedChord
  }
  const chordInfo = ALL_CHORDS[symbol.trim()]
  return chordInfo ? chordInfo.chord : undefined
}
